import store from '@/store'

export const tableColumn = [
  {
    width: 150,
    label: '问卷名称',
    value: 'taskName',
    fixed: true
  },
  {
    width: 120,
    label: '结算调查人数',
    value: 'investigatorNum',
    renderHeader: (h, { column, $index }) => {
      return h('div', { class: 'tips', style: { display: 'inline' } }, [
        h('span', column.label),
        h(
          'el-tooltip',
          {
            style: {
              position: 'relative'
            },
            attrs: {
              class: 'item',
              effect: 'dark',
              content: '选中结算项目中的调查员',
              placement: 'top-start'
            }
          },
          [
            h('img', {
              attrs: {
                src: process.env.BASE_URL + 'img/tips_red.png',
                width: 14
              }
            })
          ]
        )
      ])
    }
  },
  {
    width: 120,
    label: '到手金额（元）',
    value: 'totalYuanAmount',
    renderHeader: (h, { column, $index }) => {
      return h('div', { class: 'tips', style: { display: 'inline' } }, [
        h('span', column.label),
        h(
          'el-tooltip',
          {
            style: {
              position: 'relative'
            },
            attrs: {
              class: 'item',
              effect: 'dark',
              content: `调查员实际到手金额（已扣除${store.getters.accountingRate || 6.5}% ）`,
              placement: 'top-start'
            }
          },
          [
            h('img', {
              attrs: {
                src: process.env.BASE_URL + 'img/tips_red.png',
                width: 14
              }
            })
          ]
        )
      ])
    }
  },
  {
    width: 110,
    label: '服务费（元）',
    value: 'rateAmount',
    renderHeader: (h, { column, $index }) => {
      return h('div', { class: 'tips', style: { display: 'inline' } }, [
        h('span', column.label),
        h(
          'el-tooltip',
          {
            style: {
              position: 'relative'
            },
            attrs: {
              class: 'item',
              effect: 'dark',
              content: `服务费为 ${store.getters.accountingRate || 6.5}% 用于调查员代缴税及平台技术服务费`,
              placement: 'top-start'
            }
          },
          [
            h('img', {
              attrs: {
                src: process.env.BASE_URL + 'img/tips_red.png',
                width: 14
              }
            })
          ]
        )
      ])
    }
  },
  {
    width: 120,
    label: '结算总费用（元）',
    value: 'rateAfter',
    renderHeader: (h, { column, $index }) => {
      return h('div', { class: 'tips', style: { display: 'inline' } }, [
        h('span', column.label),
        h(
          'el-tooltip',
          {
            style: {
              position: 'relative'
            },
            attrs: {
              class: 'item',
              effect: 'dark',
              content: '调查员到手金额+服务费为结算总费用',
              placement: 'top-start'
            }
          },
          [
            h('img', {
              attrs: {
                src: process.env.BASE_URL + 'img/tips_red.png',
                width: 14
              }
            })
          ]
        )
      ])
    }
  },
  {
    width: 120,
    label: '审批阶段',
    value: 'action'
  },
  {
    width: 120,
    label: '发起时间',
    value: 'createTime'
  },
  {
    width: 120,
    label: '审批时间',
    value: 'endTime'
  },
  {
    label: '操作',
    value: 'opt',
    width: 90,
    fixed: 'right'
  }
]